import React, {Component} from "react";
import {connect} from "react-redux";
import {requestChangeBillingAddress, requestSetBillingAddress, requestSetTaxInfo} from "../../actions/AccountApiActions";
import AddressInline from "../../components/AddressInline";
import Button from "../../components/Button";
import TaskIcon from "./TaskIcon";

class SelectBillingAddress extends Component {

  handleChangeBillingAddress() {
    this.props.requestChangeBillingAddress(this.props.accountId);
  }

  handleUseShippingAddress() {
    this.props.requestSetBillingAddress(this.props.accountId, this.props.shippingAddress.toJS());
  }

  handleChangeTaxId() {
    this.props.requestSetTaxInfo(this.props.accountId);
  }

  render() {
    return (
      <div className="SelectBillingAddress section">
        <TaskIcon nr="3" completed={this.props.billingAddressStatus === "provided"} />
        <div className="title">Review Billing Address</div>
        <div className="content">
          <p className="helptext">Please note that billing details are connected to your account, and will be used for any future transactions.</p>
          {this.renderBillingAddress()}
        </div>
      </div>
    )
  }

  renderBillingAddress() {
    if (this.props.billingAddressStatus !== "provided") {
      return this.renderMissingBillingAddress()
    }
    return this.renderProvidedBillingAddress()
  }

  renderMissingBillingAddress() {
    let shippingAddressProvided = this.props.shippingAddressStatus === "provided";
    return (
      <div className="BillingAddress">
        <p className="helptext">You have not yet provided a billing address</p>
        <div className="buttons">
          <Button label="Set Address" primary={true} onClick={this.handleChangeBillingAddress.bind(this)} />
          <Button label="Use Shipping Address" link={true} active={shippingAddressProvided} onClick={this.handleUseShippingAddress.bind(this)} />
        </div>        
      </div>
    )
  }

  renderProvidedBillingAddress() {
    let shippingAddressProvided = this.props.shippingAddressStatus === "provided";
    let taxId = this.props.billingTaxId;
    let taxDescription = <p key="tax_id">If you would like to associate a tax id to your order and account, click the button below.</p>
    let taxExemptionDescription = null;
    let taxButtonLabel = "Add Tax Id";
    if (taxId && taxId !== "") {
      taxDescription = <p key="tax_id">Tax Id: <strong>{taxId}</strong></p>
      taxButtonLabel = "Change Tax Id"
    }
    if (this.props.billingTaxExempt === true) {
      taxExemptionDescription = <p key="tax_exemption_id">This account is tax exempt, and the provided description will appear on the invoice: <pre>{this.props.billingTaxExemptionDescription}</pre></p>
    }

    return (
      <div className="BillingAddress">
        <AddressInline 
          inline={false}
          showType={false}
          address={this.props.billingAddress} />      
        <div className="buttons">
          <Button label="Change Address" onClick={this.handleChangeBillingAddress.bind(this)} />
          <Button label="Use Shipping Address" link={true} active={shippingAddressProvided} onClick={this.handleUseShippingAddress.bind(this)} />
        </div>        

        {taxExemptionDescription}

        {taxDescription}        
        <div className="buttons">
          <Button label={taxButtonLabel} primary={false} onClick={this.handleChangeTaxId.bind(this)} />
        </div>
      </div>
    )
  }

}

export default connect(null, {
  requestChangeBillingAddress,
  requestSetBillingAddress,
  requestSetTaxInfo
  })(SelectBillingAddress);